import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

// Auto-opens the Bootstrap modal it is attached to, then strips the ?share
// param so a refresh doesn't reopen it. Used to bring the share modal back
// up after a full-page action like the visibility toggle.
export default class extends Controller {
    connect() {
        bootstrap.Modal.getOrCreateInstance(this.element).show()
        try {
            let url = new URL(window.location.href)
            if (url.searchParams.has("share")) {
                url.searchParams.delete("share")
                window.history.replaceState(null, "", url.toString())
            }
        } catch {
            // URL cleanup is cosmetic only
        }
    }
}
